import fetch from 'lib/fetch'
import { RequestMethod } from './RequestMethod'
import { INSURANCE_CATALOG_ENDPOINT } from './constants'

export default async function getInsuranceCatalog(): Promise<
  APIResponse.InsuranceCatalog[]
> {
  return fetch(INSURANCE_CATALOG_ENDPOINT, { method: RequestMethod.GET })
}
